import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TimelineService } from 'src/app/timeline/timeline.service';

@Component({
    selector: 'app-add-quantity',
    templateUrl: './add-quantity.component.html',
    styleUrls: ['./add-quantity.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddQuantityComponent implements OnInit {

	@Input() task: any;
	@Input() project: any;
	@Input() chapter: any;
	@Output() closeView = new EventEmitter<any>();
	@Output() notify = new EventEmitter<any>();

	loading: boolean = false;
	formData: any = {
		'task_id': null,
		'quantity': null,
		'apply': false,
		'episode': null
	}

	submitForm() {
		this.loading = true;
		this._tS.changeQuantityTask(this.formData).subscribe(
			data => {
				this.loading = false;
				this.notify.emit();
			}
		);
	}

	close() {
		this.closeView.emit()
	}

	fillForm() {
		this.formData.task_id = this.task.id;
		this.formData.quantity = this.chapter.quantity;
		this.formData.apply = this.chapter.apply_quantity ? true : false;
		this.formData.episode = this.chapter.text;
	}

	constructor(public _gS: GlobalService, private _tS: TimelineService) { }

	ngOnInit() {
		if (this.chapter) {
			this.fillForm();
		}
	}

}
